import React from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

const FieldInput = ({ id, type, name, placeholder, validation, value, onchange, mask }) => {

    const validClass = validation.status === null ? '' : validation.status ? 'valid' : 'invalid';

    const maskPhone = <InputMask
        mask="8 (999) 999-99-99"
        value={value}
        onChange={e => onchange(e.target.value.replace(/\D+/g, ''))} >
        {() => <input id={id}
            type={type}
            name={name}
            value={value}
            placeholder={placeholder}
            className={`form-control is-${validClass}`}
        />}
    </InputMask>;

    const input = <input id={id}
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        className={`form-control is-${validClass}`}
        onChange={e => onchange(e.target.value)}
    />;

    return (
        <div className="row align-items-center">
            <label htmlFor={id} className="col-sm-5 form-label mb-sm-0 fw-bold">
                {placeholder}
            </label>
            <div className="col">
                {mask ? maskPhone : input}
                {
                    validation.status === false &&
                    <div className={`${validClass}-feedback`}>
                        {validation.message}
                    </div>
                }
            </div>
        </div>
    );
};

export default FieldInput;

FieldInput.propTypes = {
    id: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    validation: PropTypes.object,
    placeholder: PropTypes.string,
    onchange: PropTypes.func,
    mask: PropTypes.bool,
};

FieldInput.defaultProps = {
    type: 'text',
    placeholder: '',
    validation: { status: null, message: null },
    onchange: () => { },
    mask: false
};